import React from "react";
import defaultTheme,{commonColor} from '../theme.css'
const ProgressBar = (props) => {
    const { bgcolor, filledColor, completed } = props;

    const containerStyles = {
        height: 10,
        width: '100%',
        backgroundColor: bgcolor ? bgcolor : commonColor.color_7,
        borderRadius: 50,
        marginTop: defaultTheme.spacing * 2,
        marginBottom: defaultTheme.spacing * 2,
        // margin: 50
    }

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: filledColor ? filledColor : commonColor.color_3,
        borderRadius: 'inherit',
        textAlign: 'right'
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold'
    }

    return (
        <div style={containerStyles}>
            <div style={fillerStyles}/>
        </div>
    );
};

export default ProgressBar;